import {Controller} from "stimulus";

export default class extends Controller {
  static targets = ["details"];

  toggle() {
    if (this.hasDetailsTarget) {
      this.detailsTarget.classList.toggle("hidden");
    }
  }
}
